import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from 'redux/actions'

import modalsSelector from 'redux/selectors/modals/modal_selector'
import Share from 'components/share/share'
import BindersLessonsPickerModal from 'views/binders/modals/lessons_picker/binders_lessons_picker_modal'
import BindersLessonCodesModal from 'views/binders/modals/lesson_codes/binders_lesson_codes_modal'
import PrivateLibraryAddToFolderModal from 'views/admin/private_library/modals/add_to_folder/private_library_add_to_folder'
import LessonPreviewModal from 'views/modals/lesson_preview_modal'
import PlaygroundSampleModal from 'views/modals/playground_sample_modal'
import BindersCreate from 'views/binders/modals/create/binders_create_modal'
import BindersNotes from 'views/binders/modals/notes/binders_notes_modal'
import PrivateLibrarySettings from 'views/admin/private_library/modals/settings/private_library_settings_edit'
import PrivateLibraryNameFolderModal from 'views/admin/private_library/modals/name_folder/private_library_name_folder_modal'
import PrivateLibraryLessonsPickerModal from 'views/admin/private_library/modals/lessons_picker/private_library_lessons_picker_modal'
import StoreFrontLessonsPickerModal from 'views/store_front/modals/lessons_picker/storefront_lessons_picker_modal'
import StoreFrontGradesSubjectsModal from 'views/store_front/modals/grades_subjects_input/storefront_grades_subjects_modal'
import AdminOnboardingAddUserModal from 'views/admin_onboarding/modals/add_user/admin_onboarding_add_user'
import MyAccountNearpodPicker from 'views/my_account/components/picker/my_account_nearpod_picker'
import PlaygroundNearpodPicker from 'views/playground/components/picker/playground_nearpod_picker'
import PollEditSettingsModal from 'views/slides/activities/poll/components/modals/poll_edit_settings_modal'
import PollReferenceMediaPicker from 'views/slides/activities/poll/components/picker/poll_reference_media_picker'
import OEQReferenceMediaPicker from 'views/slides/activities/oeq/components/picker/oeq_reference_media_picker'
import QuizNearpodPicker from 'views/quiz/components/picker/quiz_nearpod_picker'
import DrawItReferenceMediaFilePicker from 'views/slides/activities/draw_it/components/picker/reference_media_file_picker'
import DrawItBackgroundImagePicker from 'views/slides/activities/draw_it/components/picker/background_image_picker'
import MediaPreview from 'components/media_preview_container/media_preview_container'
import SwitchLibraryModal from 'views/admin/private_library/modals/switch_library/switch_library_modal'
import MatchingPairsCtPair from 'containers/creation_tool/matching_pairs/modals/pair_editor_modal_container'
import MatchingPairsCtTimer from 'containers/creation_tool/matching_pairs/modals/timer_modal_container'
import PollCtTimer from 'containers/creation_tool/poll/modals/timer_modal_container'
import OEQCtTimer from 'containers/creation_tool/oeq/modals/timer_modal_container'
import DrawItCtTimer from 'containers/creation_tool/draw_it/modals/timer_modal_container'
import MatchingPairsCtAddImagePicker from 'containers/creation_tool/matching_pairs/modals/add_image_picker_container'
import MatchingPairsCtPreview from 'containers/creation_tool/matching_pairs/modals/preview_container'
import LessonCodesLaunchLiveSessionModal from 'views/my_library/modals/lesson_codes_launch_live_session/my_library_launch_live_session'
import LessonCodesLaunchStudentPacedModal from 'views/my_library/modals/lesson_codes_launch_student_paced/my_library_launch_student_paced'
import StudentPacedLaunchModal from 'views/my_library/modals/student_paced_launch_modal/my_library_launch_homework'
import MyLibrarySaveChangesModal from 'views/my_library/modals/save_changes_modal/my_library_save_changes_modal'
import MyLibraryAddToFolder from 'views/my_library/modals/add_to_folder/my_library_add_to_folder'
import MyLibraryNameFolderModal from 'views/my_library/modals/name_folder/my_library_name_folder_modal'
import MyLibraryAddMultipleLessonsToFolder from 'views/my_library/modals/lessons_picker/my_library_lessons_picker_modal'
import MyLibraryLaunchSessionTeams from 'views/my_library/modals/launch_session_teams/my_library_launch_session_teams'
import UnlockLessonsModal from 'views/private_library/modals/unlock_lessons/unlock_lessons_modal'
import ReferContactModal from 'views/admin_onboarding/modals/refer_contact/refer_contact_modal'
import PasswordForm from 'views/my_account/modals/confirm_password/my_account_confirm_password_form'
import QuizTimer from 'containers/creation_tool/quiz/modals/timer_modal_container'
import GameQuestionTimer from 'containers/creation_tool/game/modals/timer_question_modal_container'
import ImageAnswerPicker from 'views/slides/activities/game/components/picker/image_answer_picker'
import GameQuestionImagePicker from 'views/slides/activities/game/components/picker/question_image_picker'
import QuickLaunchTimerCreate from 'containers/quick_launch/timer/modals/timer_create_modal_container'
import InteractiveVideoSettingsModal from 'containers/interactive_video/modals/interactive_video_settings_modal_container.jsx'
import QuickLaunchCollaborateCreate from 'containers/quick_launch/collaborate/ql_collaborate_create_modal_container'
import InteractiveVideoActivityPickerModal from 'containers/creation_tool/interactive_video/create/modals/interactive_video_activity_picker_modal_container'
import AddToPrivateLibraryContainer from 'containers/my_library/modals/add_lesson_to_private_library_folder'
import TeachModalContainer from 'containers/my_library/modals/teach_lesson'
import InteractiveVideoTrimTooltip from 'containers/creation_tool/interactive_video/create/modals/interactive_video_trim_tooltip_container'
import InteractiveVideoTrimChangeNotSaved from 'containers/creation_tool/interactive_video/create/modals/interactive_video_trim_change_not_saved_container'
import GoogleSlidesUnauthorizedCreate from 'containers/paywalls/modals/google_slides_unauthorized_create'
import modalTypes from 'helpers/enums/modalTypes'


class ModalsController extends Component {

	showVisible(modal, index) {

		if (modal) {
			/* Global */
			if (modal.modalName === modalTypes.LESSON_PREVIEW) {
				return <LessonPreviewModal
					entityUID={ modal.params.entityUID }
					privateLibraryId={ modal.params.privateLibraryId }
					bundleId={ modal.params.bundleId }
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.SHARE) {
				return <Share
					modalName={ modal.modalName }
					entityUID={ modal.params.entityUID }
					entityType={ modal.params.entityType }
					libraryID={ modal.params.libraryID }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.MEDIA_PREVIEW) {
				return <MediaPreview
					modalName={ modal.modalName }
					mediaType={ modal.params.mediaType }
					mediaVersions={ modal.params.mediaVersions }
					key={index}
				/>
			}
			/* Playground */
			if (modal.modalName === modalTypes.PLAYGROUND_SAMPLE) {
				return <PlaygroundSampleModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.PLAYGROUND_NEARPOD_PICKER) {
				return <PlaygroundNearpodPicker
					modalName={ modal.modalName }
					key={index}
					pickerType={ modal.params.pickerType }
				/>
			}
			/* Binders */
			if (modal.modalName === modalTypes.BINDERS_CREATE) {
				return <BindersCreate
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.BINDERS_NOTES) {
				return <BindersNotes
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.BINDERS_LESSONS_PICKER) {
				return <BindersLessonsPickerModal
					entityUID={ modal.params.entityUID }
					folderName={ modal.params.folderName }
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.BINDERS_LESSON_CODES) {
				return <BindersLessonCodesModal
					key={index}
				/>
			}
			/* Private Library */
			if (modal.modalName === modalTypes.PRIVATE_LIBRARY_SETTINGS) {
				return <PrivateLibrarySettings
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.PRIVATE_LIBRARY_NAME_FOLDER) {
				return <PrivateLibraryNameFolderModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.PRIVATE_LIBRARY_LESSONS_PICKER) {
				return <PrivateLibraryLessonsPickerModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			/* Admin Onboarding */
			if (
				modal.modalName === modalTypes.ADMIN_ONBOARDING_ADD_USER
				&& modal.visible === true
			) {
				return <AdminOnboardingAddUserModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.PRIVATE_LIBRARY_ADD_TO_FOLDER) {
				return <PrivateLibraryAddToFolderModal
					modalName={ modal.modalName }
					entity={ modal.params.entity }
					key={index}
				/>
			}
			/* My Account */
			if (modal.modalName === modalTypes.MY_ACCOUNT_NEARPOD_PICKER) {
				return <MyAccountNearpodPicker
					modalName={ modal.modalName }
					key={index}
				/>
			}
			/* Poll */
			if (modal.modalName === modalTypes.POLL_SETTINGS) {
				return <PollEditSettingsModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.POLL_NEARPOD_PICKER) {
				return <PollReferenceMediaPicker
					modalName={ modal.modalName }
					key={index}
					pickerType={ modal.params.mediaType }
					questionId={ modal.params.questionId }
				/>
			}
			if (modal.modalName === modalTypes.POLL_CT_TIMER) {
				return <PollCtTimer
					modalName={modal.modalName}
					key={index}
				/>
			}
			/* OEQ */
			if (modal.modalName === modalTypes.OEQ_CT_TIMER) {
				return <OEQCtTimer
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.OEQ_NEARPOD_PICKER) {
				return <OEQReferenceMediaPicker
					modalName={ modal.modalName }
					key={index}
					pickerType={ modal.params.mediaType }
					questionId={ modal.params.questionId }
				/>
			}
			/* Quiz */
			if (modal.modalName === modalTypes.QUIZ_NEARPOD_PICKER) {
				return <QuizNearpodPicker
					modalName={ modal.modalName }
					key={index}
					pickerType={ modal.params.mediaType }
					questionId={ modal.params.questionId }
				/>
			}
			/* Matching Pairs */
			if (modal.modalName === modalTypes.MATCHING_PAIRS_CT_PAIR) {
				return <MatchingPairsCtPair
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.MATCHING_PAIRS_CT_TIMER) {
				return <MatchingPairsCtTimer
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (
				modal.modalName === modalTypes.MATCHING_PAIRS_ADD_IMAGE_PICKER
			) {
				return <MatchingPairsCtAddImagePicker
					modalName={modal.modalName}
					key={index}
					pickerType={ modal.params.mediaType }
					cardName={ modal.params.cardName }
					clientId={ modal.params.clientId }
				/>
			}
			if (modal.modalName === modalTypes.MATCHING_PAIRS_CT_PREVIEW) {
				return <MatchingPairsCtPreview
					modalName={modal.modalName}
					key={index}
				/>
			}
			/* Storefront */
			if (modal.modalName === modalTypes.STOREFRONT_LESSONS_PICKER) {
				return <StoreFrontLessonsPickerModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (
				modal.modalName === modalTypes.STOREFRONT_GRADES_SUBJECTS_PICKER
			) {
				return <StoreFrontGradesSubjectsModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			/* DrawIt */
			if (modal.modalName === modalTypes.DRAW_IT_REFERENCE_MEDIA_PICKER) {
				return <DrawItReferenceMediaFilePicker
					modalName={ modal.modalName }
					key={index}
					pickerType={ modal.params.mediaType }
				/>
			}
			if (
				modal.modalName === modalTypes.DRAW_IT_BACKGROUND_IMAGE_PICKER
			) {
				return <DrawItBackgroundImagePicker
					modalName={ modal.modalName }
					key={index}
					pickerType={ modal.params.mediaType }
				/>
			}
			if (modal.modalName === modalTypes.SWITCH_LIBRARY) {
				return <SwitchLibraryModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.DRAW_IT_CT_TIMER) {
				return <DrawItCtTimer
					modalName={modal.modalName}
					key={index}
				/>
			}
			/* My Library */
			if (
				modal.modalName === modalTypes.LESSON_CODES_LAUNCH_LIVE_SESSION
			) {
				return <LessonCodesLaunchLiveSessionModal
					modalName={ modal.modalName }
					key={index}
					presentation_uid={ modal.params.presentation_uid }
					hasZoom={ modal.params.hasZoom }
				/>
			}
			if (
				modal.modalName === modalTypes.LESSON_CODES_LAUNCH_STUDENT_PACED
			) {
				return <LessonCodesLaunchStudentPacedModal
					modalName={ modal.modalName }
					key={index}
					presentationUid={ modal.params.presentationUid }
				/>
			}
			if (modal.modalName === modalTypes.MY_LIBRARY_LAUNCH_HOMEWORK) {
				return <StudentPacedLaunchModal
					modalName={ modal.modalName }
					key={index}
					sessionUid={ modal.params.sessionUid }
					presentationUid={ modal.params.presentationUid }
				/>
			}
			if (modal.modalName === modalTypes.SAVE_CHANGES) {
				return <MyLibrarySaveChangesModal
					modalName={modal.modalName}
					key={index}
					entity={modal.params.entity}
				/>
			}
			if (modal.modalName === modalTypes.MY_LIBRARY_ADD_TO_FOLDER) {
				return <MyLibraryAddToFolder
					modalName={modal.modalName}
					key={index}
					entity={modal.params.entity}
				/>
			}
			if (modal.modalName === modalTypes.MY_LIBRARY_NAME_FOLDER) {
				return <MyLibraryNameFolderModal
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER) {
				return <MyLibraryAddMultipleLessonsToFolder
					modalName={modal.modalName}
					key={index}
					folder={modal.params.folder}
				/>
			}
			if (
				modal.modalName === modalTypes.MY_LIBRARY_LAUNCH_SESSION_TEAMS
			) {
				return <MyLibraryLaunchSessionTeams
					modalName={modal.modalName}
					key={index}
					presentationUid={modal.params.presentationUid}
					payload={modal.params.payload}
					sessionType={modal.params.sessionType}
				/>
			}
			/* Quick Launch */
			if (modal.modalName === modalTypes.QUICK_LAUNCH_TIMER_CREATE) {
				return <QuickLaunchTimerCreate
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (
				modal.modalName === modalTypes.QUICK_LAUNCH_COLLABORATE_CREATE
			) {
				return <QuickLaunchCollaborateCreate
					modalName={modal.modalName}
					key={index}
				/>
			}
			/* Interactive Video */
			if (
				modal.modalName === modalTypes.INTERACTIVE_VIDEO_ACTIVITY_PICKER
			) {
				return <InteractiveVideoActivityPickerModal
					modalName={modal.modalName}
					key={index}
					breakpointClientId={modal.params.breakpointClientId}
				/>
			}
			if (modal.modalName === modalTypes.INTERACTIVE_VIDEO_SETTINGS) {
				return <InteractiveVideoSettingsModal
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.INTERACTIVE_VIDEO_EDITOR_TRIM_TOOLTIP) {
				return <InteractiveVideoTrimTooltip
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.INTERACTIVE_VIDEO_TRIM_CHANGE_NOT_SAVED) {
				return <InteractiveVideoTrimChangeNotSaved
					key={index}
				/>
			}
			/* General */
			if (modal.modalName === modalTypes.UNLOCK_LESSONS) {
				return <UnlockLessonsModal
					modalName={modal.modalName}
					key={index}
					learnMoreRedirect={modal.params.learnMoreRedirect}
					sampleLessonsRedirect={modal.params.sampleLessonsRedirect}
					privateLibraryTitle={modal.params.privateLibraryTitle}
				/>
			}
			if (modal.modalName === modalTypes.REFER_CONTACT) {
				return <ReferContactModal
					modalName={ modal.modalName }
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.SHOW_PASSWORD_FORM) {
				return <PasswordForm
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.QUIZ_TIMER) {
				return <QuizTimer
					modalName={modal.modalName}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.GAME_TIMER_QUESTION) {
				return <GameQuestionTimer
					modalName={modal.modalName}
					value={modal.params.value}
					id={modal.params.id}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.GAME_IMAGE_ANSWER_PICKER) {
				return <ImageAnswerPicker
					modalName={modal.modalName}
					questionId={modal.params.questionId}
					answerId={modal.params.answerId}
					key={index}
				/>
			}
			if (modal.modalName === modalTypes.GAME_QUESTION_MEDIA_PICKER) {
				return <GameQuestionImagePicker
					modalName={modal.modalName}
					questionId={modal.params.questionId}
					answerId={modal.params.answerId}
					key={index}
					pickerType={modal.params.mediaType}
				/>
			}
			if (modal.modalName === modalTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY) {
				return <AddToPrivateLibraryContainer
					key={index}
					libraryType={modal.params.libraryType}
					lesson={modal.params.lesson}
				/>
			}
			if (modal.modalName === modalTypes.MY_LIBRARY_TEACH_MODAL) {
				return <TeachModalContainer
					key={index}
					entity={modal.params.entity}
				/>
			}
			if (modal.modalName === modalTypes.GOOGLE_SLIDES_UNAUTHORIZED_CREATE) {
				return <GoogleSlidesUnauthorizedCreate
					key={index}
				/>
			}
		}
		return null

	}

	componentDidCatch(error) {
		// eslint-disable-next-line no-console
		console.log('componentDidCatch: MODAL:', error)
	}

	render() {
		return (
			<div>
				{ this.showVisible(this.props.modal, 0) }
			</div>
		)
	}
}

ModalsController.propTypes = {
	modal: PropTypes.object,
}

function mapStateToProps(state) {
	return modalsSelector(state)
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalsController)
